// react
import React from "react";

function ProductTabSpecification(props) {
    const { specs } = props;
    const sections =
        specs && specs[0]
            ? specs.map((section, index) => {
                  return (
                      <div key={index} className="spec__row">
                          <div className="spec__name">
                              {section.key.charAt(0).toUpperCase() + section.key.substring(1)} :
                          </div>
                          <div className="spec__value">{section.value}</div>
                      </div>
                  );
              })
            : null;

    return (
        <div className="spec">
            {/* <h3 className="spec__header">Specification</h3> */}
            {sections}
            {/* <div className="spec__disclaimer">
                Information on technical characteristics, the delivery set, the country of
                manufacture and the appearance of the goods is for reference only and is based on
                the latest information available at the time of publication.
            </div> */}
        </div>
    );
}

export default ProductTabSpecification;
